import axios from 'axios';
import { Capacitor } from '@capacitor/core';
import { getNativeRefreshToken, setNativeRefreshToken } from 'src/utils/native-secure-storage';

const API_BASE = import.meta.env.VITE_API_URL; 
const isNativeApp = Capacitor.isNativePlatform();

// Plain axios instance (no interceptors)
const plainAxios = axios.create({
  baseURL: API_BASE,
  withCredentials: true, // still send cookies for web
  timeout: 10000, // avoid indefinite hangs
  headers: {
    'Content-Type': 'application/json',
  },
});

export async function refreshToken() {
  try {
    const bodyToken = isNativeApp ? await getNativeRefreshToken() : null;

    const payload = {
      isNativeApp,
      token: bodyToken || null
    };

    // POST directly to the refresh endpoint, bypassing your api instance
    const response = await plainAxios.post('/auth/refresh', payload);

    const newAccessToken = response?.data?.token || null;
    const newRefreshToken = response?.data?.refreshToken || null;

    // If server returned a refresh token (native), persist it securely
    if (isNativeApp && newRefreshToken) {
      try {
        await setNativeRefreshToken(newRefreshToken);
      } catch (e) {
        console.warn('Failed to persist native refresh token', e);
      }
    }

    return newAccessToken;
  } catch (err) {
    // Important: return null on failure (do NOT throw), so callers can unstick
    console.error('Token refresh failed', err);
    return null;
  }
}
